export default __webpack_public_path__ + "static/media/products-3.9971c40a.webp";